import { render, staticRenderFns } from "./IfSet.vue?vue&type=template&id=3768b466&scoped=true&"
import script from "./IfSet.vue?vue&type=script&lang=js&"
export * from "./IfSet.vue?vue&type=script&lang=js&"
import style0 from "./IfSet.vue?vue&type=style&index=0&id=3768b466&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3768b466",
  null
  
)

export default component.exports